export default __webpack_public_path__ + "static/iconography-image-c-fa0382b4c4083da2e2e5078d16a969c3.png";